/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import {
  AbstractRestService,
  arrayOf,
  file,
  identity,
  none,
  optimisticLockingOf,
  RestSettings,
} from '@gh/core-data';
import { Observable } from 'rxjs';
import {
  LicenseAgreementDetailsDto,
  LicenseAgreementListItemDto,
  UserLicenseAgreementDto,
} from './license-agreements.dto';
import {
  LicenseAgreementDetailsMapper,
  LicenseAgreementListItemMapper,
} from './license-agreements.mapper';

@Injectable()
export class LicenseAgreementRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  findAll(): Observable<LicenseAgreementListItemDto[]> {
    return this.httpGet(`${this.bp}/license-agreements`, arrayOf(LicenseAgreementListItemMapper));
  }

  create(details: LicenseAgreementDetailsDto): Observable<LicenseAgreementDetailsDto> {
    return this.httpPost(`${this.bp}/license-agreements`, details, optimisticLockingOf(LicenseAgreementDetailsMapper));
  }

  get(id: ID): Observable<LicenseAgreementDetailsDto> {
    return this.httpGet(`${this.bp}/license-agreements/${id}`, optimisticLockingOf(LicenseAgreementDetailsMapper));
  }

  update(details: LicenseAgreementDetailsDto): Observable<LicenseAgreementDetailsDto> {
    return this.httpPut(
      `${this.bp}/license-agreements/${details.id}`,
      details,
      optimisticLockingOf(LicenseAgreementDetailsMapper));
  }

  getUserAgreement(): Observable<UserLicenseAgreementDto> {
    return this.httpGet(`${this.bp}/users/agreements`, identity());
  }

  acceptUserAgreement(agreement: UserLicenseAgreementDto): Observable<void> {
    return this.httpPut(`${this.bp}/users/agreements`, agreement, identity(), none());
  }

  downloadLicenseAgreement(id: ID): Observable<Blob> {
    return this.httpGet(`${this.bp}/license-agreements/${id}/download`, file());
  }
}
